import { render } from "./BankDokumen.vue?vue&type=template&id=3bad49a1"
import script from "./BankDokumen.vue?vue&type=script&lang=js"
export * from "./BankDokumen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__